import { MetadataEntity, MetadataGrid } from 'api/index'
import React from 'react'

interface SelectedItem {
  type: string
  field?: string
}

interface AppGridLayoutDesigerContext {
  view: string
  chgView: (view: string) => void
  currSelectd: SelectedItem
  setCurrSelected: (currSelectd: SelectedItem) => void
  metadataGird: MetadataGrid
  setMetadataGrid: (metadataGird: MetadataGrid) => void
  loadFieldList: (metadataGird: MetadataGrid) => void
  metadataEntity: MetadataEntity
  tableViewId: number
  setTableViewId: (tableViewId: number) => void
}

export const AppGridLayoutDesigerContext = React.createContext<AppGridLayoutDesigerContext>(
  {} as AppGridLayoutDesigerContext
)



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppGridLayoutDesiger/AppGridLayoutDesigerContext.tsx